import {
  EDeliveryStatus,
  ELoadingOrderStatus,
  EPrepareStatus,
  EProductionPlanType,
  EReceiveStatus,
} from "model";
import {
  CCP_LOCATION_STATUS,
  COUNT_TYPE,
  DELIVERY_TICKET_STATUS,
  LOADING_ORDER_STATUS,
  MATERIAL_REQUIREMENT_STATUS,
  PREPARE_DOCUMENT_STATUS,
  PRODUCTION_PLAN_STATUS,
  RECEIVE_DOCUMENT_STATUS,
} from "common";
import { I18nTranslator, translations } from "utils/i18n";
import { ECountType } from "model/Type/ECountType";
import { ECCPLocationStatus } from "model/Type/ECCPLocationStatus";
import { EMaterialRequirement } from "model/Type/EMaterialRequirement";

export const getReceiveStatusString = (statiusType: EReceiveStatus) => {
  const translate = RECEIVE_DOCUMENT_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getLOStatusString = (statiusType: ELoadingOrderStatus) => {
  const translate = LOADING_ORDER_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getPrepareStatusString = (statiusType: EPrepareStatus) => {
  const translate = PREPARE_DOCUMENT_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getDeliveryStatusString = (statiusType: EDeliveryStatus) => {
  const translate = DELIVERY_TICKET_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getProductionPlanStatusString = (
  statiusType: EProductionPlanType
) => {
  const translate = PRODUCTION_PLAN_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getMaterialRequisitionStatusString = (
  statiusType: EMaterialRequirement
) => {
  const translate = MATERIAL_REQUIREMENT_STATUS.find(
    (status) => status.type === statiusType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getCountTypeString = (countType: ECountType) => {
  const translate = COUNT_TYPE.find((status) => status.type === countType)
    ?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getCCPLocationStatusString = (countType: ECCPLocationStatus) => {
  const translate = CCP_LOCATION_STATUS.find(
    (status) => status.type === countType
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getProgressStatusByQuantity = (
  currentQuantity: number,
  planningQuantity: number
) => {
  const isNew = currentQuantity === 0;
  const isProcessing = currentQuantity < planningQuantity;
  const isComplete = currentQuantity === planningQuantity;
  const isCancel = planningQuantity === 0;

  switch (true) {
    case isNew:
      return translations.statusType.new;
    case isProcessing:
      return translations.statusType.inProgress;
    case isComplete:
      return translations.statusType.completed;
    case isCancel:
      return translations.statusType.cancel;
    default:
      return translations.statusType.error;
  }
};
